import {
  Modal as ChakraModal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text,
  ModalFooter,
  Button,
  Checkbox,
  Stack
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { UserService } from '../../../services/User/UserService'

interface IProps {
  isOpen: boolean
  onClose: () => void
  user: any
  roles: { id: number; name: string }[]
}

export function UserSetRolesModal({ isOpen, onClose, user, roles }: IProps) {
  const userService = new UserService()
  const [selectedRoles, setSelectedRoles] = useState<number[]>([])

  useEffect(() => {
    setSelectedRoles(user.roles.map((role: string) => roles.find((r) => r.name === role)?.id))
  }, [user, isOpen])

  const handleSave = async () => {
    await userService.updateRoles(user.id, selectedRoles)
    onClose()
  }

  return (
    <ChakraModal isOpen={isOpen} onClose={onClose} size="sm">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{user.name}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb={4}>
            {user.pending_approval &&
              'Para aprovar o acesso do usuário, selecione abaixo os grupos que serão aplicados.'}
            {!user.pending_approval && 'Selecione abaixo os grupos que o usuário pertence.'}
          </Text>

          <Stack direction="column">
            {roles.map((role) => (
              <Checkbox
                key={role.id}
                isChecked={selectedRoles.includes(role.id)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedRoles([...selectedRoles, role.id])
                  } else {
                    setSelectedRoles(selectedRoles.filter((id) => id !== role.id))
                  }
                }}
              >
                {role.name}
              </Checkbox>
            ))}
          </Stack>

          <Text mt={4} fontSize="sm" color="gray.500">
            {selectedRoles.length === 0 && 'Selecione pelo menos um grupo'}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={handleSave} disabled={selectedRoles.length === 0}>
            Salvar
          </Button>
          <Button variant="ghost" onClick={onClose}>
            Cancelar
          </Button>
        </ModalFooter>
      </ModalContent>
    </ChakraModal>
  )
}
